export default "__VITE_ASSET__BhFHqbew__"